import { configureStore } from '@reduxjs/toolkit'
import projectArrReducer from '../src/features/metadata/MetadataLogic'
export const store = configureStore({
    reducer: {
        project: projectArrReducer,
    },
})